import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';
import { v4 as uuidv4 } from 'uuid';

export class AccountService {
  static async createClientToAccount(accoundId, data) {
    return await api.post(`${API_URLS.ACCOUNTS_V3}/${accoundId}/user`, data);
  }

  static async createAccount(data) {
    return await api.post(API_URLS.ACCOUNTS_V3, data);
  }

  static async getAccountsList() {
    return await api.get(API_URLS.ACCOUNTS_V3, {
      params: { limit: -1, offset: 0 },
    });
  }

  static async getAccount(data) {
    const { id } = data;
    return await api.get(`${API_URLS.ACCOUNTS_V3}/${id}`);
  }

  static async updateAccount(payloud) {
    const { accountId, data } = payloud;
    return await api.put(`${API_URLS.ACCOUNTS_V3}/${accountId}`, data);
  }

  static async addRelatedPerson(payload) {
    const { accountId, data } = payload;
    return await api.post(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${data.id}/bind`,
      data,
    );
  }

  static async updateRelatedPerson(payload) {
    const { accountId, userId, data } = payload;
    return await api.put(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${userId}`,
      data,
    );
  }

  static async getRelatedAccount(id) {
    return await api.get(`${API_URLS.ACCOUNTS_V3}/${id}/user`);
  }

  static async deleteRelatedPerson({ accountId, userId }) {
    return await api.delete(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${userId}`,
    );
  }

  static async setClientType(data) {
    const { id, type } = data;
    return await api.post(`${API_URLS.SET_CLIENT_TYPE}/${id}/type`, {
      ...type,
      client_id: +id,
    });
  }

  static async updateClientInfo(data) {
    const { id, client } = data;
    return await api.put(`${API_URLS.UPDATE_CLIENT}/${id}`, client);
  }

  static async addClientPhone(data) {
    const { id, phone } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/phone`, { phone });
  }

  static async updateClientPhone(data) {
    const { id, ID, phone } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/phone`, {
      ID,
      phone,
    });
  }

  static async deleteClientPhone(data) {
    const { id, phoneID } = data;
    return await api.delete(`${API_URLS.CLIENT}/${id}/phone/${phoneID}`);
  }

  static async getRepresentative(clientID) {
    return await api.get(`/v1/clients/${clientID}/company/representive`);
  }

  static async addRepresentative(data) {
    const { id, representative } = data;
    return await api.post(
      `/v1/clients/${id}/company/representive`,
      representative,
    );
  }

  static async updateRepresentative(data) {
    const { clientID, id, representative } = data;
    return await api.put(
      `/v1/clients/${clientID}/company/representive/${id}`,
      representative,
    );
  }

  static async deleteRepresentative(data) {
    const { id, ID } = data;
    return await api.delete(
      `${API_URLS.CLIENT}/${id}/company/representive/${ID}`,
    );
  }

  static async addRepresentativeDoc(data) {
    const { id, representativeId, file, type } = data;
    const sendData = new FormData(file);
    sendData.append('type', type);
    return await api.post(
      `/v1/clients/${id}/company/representive/${representativeId}/documents`,
      sendData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  }

  static async setClientMaritalStatus(data) {
    const { id, marital } = data;
    return await api.put(
      `${API_URLS.CLIENT}/${id}/marital-status-and-employment`,
      marital,
    );
  }

  static async addClientScore(data) {
    const { id, score } = data;
    return await api.put(`${API_URLS.CLIENT}/${id}/score`, score);
  }

  static async setClientAddress(data) {
    const { id, address } = data;
    return await api.put(`${API_URLS.CLIENT}/${id}/address`, address);
  }

  static async setClientData(data) {
    const { id, fields } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/data`, fields);
  }

  static async getClientData(data) {
    const { id, name } = data;
    return await api.get(`${API_URLS.CLIENT}/${id}/data/${name}`);
  }

  static async sendInvitation(data) {
    const { id, email } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/invite`, { email });
  }

  static async getInvitationInfo(data) {
    const { inviteHash } = data;
    return await api.get(`${API_URLS.INVITE}/${inviteHash}`);
  }

  static async acceptInvitation(data) {
    const { inviteHash, password } = data;
    return await api.post(`${API_URLS.INVITE}/${inviteHash}`, { password });
  }

  static async setRiskLevel(data) {
    const { id, riskSelected } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/risk`, {
      risk_level: +riskSelected,
    });
  }

  static async sendClientApprove(data) {
    const { id, status } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/approve`, { status });
  }

  static async setClientFees(data) {
    const { id, fees } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/fees`, fees);
  }

  static async getClientFees(id) {
    return await api.get(`${API_URLS.CLIENT}/${id}/fees`);
  }

  static async deleteAccount(id) {
    return await api.delete(`${API_URLS.ACCOUNTS_V3}/${id}`);
  }

  static async getFinPlan(id) {
    return await api.get(`${API_URLS.CLIENT}/${id}/financialplan`);
  }

  static async createFinPlan({ clientId, data }) {
    return await api.post(`${API_URLS.CLIENT}/${clientId}/financialplan`, data);
  }

  static async patchFinPlan({ clientId, finplanId, body }) {
    return await api.patch(
      `${API_URLS.CLIENT}/${clientId}/financialplan/${finplanId}`,
      body,
    );
  }

  static async deleteFinPlan({ finplanId }) {
    return await api.delete(`${API_URLS.FINPLAN}/${finplanId}`);
  }

  static async uploadFinancialItemImage(file) {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(
      `${API_URLS.FINPLANIMAGE}/${uuidv4()}`,
      bodyFormData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  }

  static async getSuggestionsPortfolio(userId) {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/suggestions?offset=0&limit=100`,
    );
  }

  static async getApprovedPortfolio(userId) {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/approved?offset=0&limit=100`,
    );
  }

  static async getExecutedPortfolio(userId) {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/executing?offset=0&limit=100`,
    );
  }

  static async getImplementedPortfolio(userId) {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/implemented?offset=0&limit=100`,
    );
  }

  static async getAllApprovedPortfolio() {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/approved`, {
      params: { limit, offset },
    });
  }

  static async getAllExecutedPortfolio() {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/executing`, {
      params: { limit, offset },
    });
  }

  static async getAllImplementedPortfolio() {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/implemented`, {
      params: { limit, offset },
    });
  }

  static async approveSuggestions({ userId, candidatId }) {
    return await api.post(
      `${API_URLS.CLIENT}/${userId}/candidate/${candidatId}/approve`,
    );
  }

  static async deleteSuggestions({ userId, candidatId }) {
    return await api.delete(
      `${API_URLS.CLIENT}/${userId}/candidate/${candidatId}`,
    );
  }
  /* eslint-disable camelcase */

  static async getCandidatTransactions({ portfolio_id, candidatId }) {
    return await api.get(
      `${API_URLS.PORTFOLIO}/${portfolio_id}/candidate/${candidatId}/transactions`,
    );
  }

  // TODO
  static async executeApprovedPortfolio({ portfolioId, candidatId }) {
    return await api.post(
      `${API_URLS.PORTFOLIO}/${portfolioId}/candidate/${candidatId}/execute`,
    );
  }

  static async implementePortfolio({ portfolioId, candidatId }) {
    return await api.post(
      `${API_URLS.PORTFOLIO}/${portfolioId}/candidate/${candidatId}/executed`,
    );
  }

  static async downloadPdfReport({
    lang = 'sw',
    type = 'pdf',
    timeZone = '',
    portfolio_id,
    client_id,
  }) {
    return await api.get(
      `${API_URLS.PORTFOLIO_V3}/${portfolio_id}/candidate/${client_id}/transactionsreport?type=${type}&lang=${lang}&timezone=${timeZone}`,
      {
        responseType: 'blob',
      },
    );
  }

  static async getOnboardingStatus({ clientId }) {
    return await api.get(`${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`);
  }

  static async postOnboardingData(data) {
    const { clientId, ...rest } = data;
    return await api.post(`${API_URLS.V2_CLIENT}/${clientId}/onboarding`, rest);
  }

  static async rescheduleOnboarding(data) {
    const { clientId, id, ...rest } = data;
    return await api.put(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/${id}`,
      rest,
    );
  }

  static async delOnboarding(clientId) {
    return await api.delete(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`,
    );
  }

  static async postOnboardingAudio({ clientId, file }) {
    return await api.post(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`,
      file,
    );
  }

  static async setOnboardingVerifed({ userId, id, data }) {
    return await api.put(
      `${API_URLS.V2_CLIENT}/${userId}/onboarding/${id}`,
      data,
    );
  }

  static async uploadOnboardingDocument({ id, docType, files }) {
    if (!files || files.length === 0) {
      throw new Error('No files provided');
    }
    const filesArray = Array.from(files);
    const bodyFormData = new FormData();
    filesArray.forEach((file, index) => {
      bodyFormData.append(`file${index + 1}`, file);
    });
    return await api.post(
      `${API_URLS.ONBOARDING}/${id}/document/${docType}`,
      bodyFormData,
    );
  }

  static async getOnboardingDocumentsList({ id }) {
    return await api.get(`${API_URLS.ONBOARDING}/${id}/document`);
  }

  static async deleteOnboardingDocument({ docID }) {
    return await api.delete(`/v2/document/${docID}`);
  }

  static async getOnboardingRiskProfile({ userId, id }) {
    return await api.get(
      `${API_URLS.V2_CLIENT}/${userId}/onboarding/${id}/risk-profile`,
    );
  }

  static async uploadOnboardingAudio({ id, file }) {
    if (!file) {
      throw new Error('No files provided');
    }
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(`${API_URLS.ONBOARDING}/${id}/audio`, bodyFormData);
  }

  static async getGooleClientId() {
    return await api.get(API_URLS.OAUTH_CONFIG_V3);
  }

  static async getGrandFinancialPlan(accountId) {
    return await api.get(`${API_URLS.ACCOUNT_V3}/${accountId}/financial`);
  }

  static async postGrandFinancialPlan({ accountId, data }) {
    return await api.post(
      `${API_URLS.ACCOUNT_V3}/${accountId}/financial`,
      data,
    );
  }

  static async updateGrandFinancialPlan({ data }) {
    const { id, ...rest } = data;
    return await api.put(`${API_URLS.FINPLAN}/${id}`, rest);
  }

  static async getFinancialCategory() {
    return await api.get('/v3/financialcategory');
  }

  static async postFinancialStage(data) {
    const { planId, ...rest } = data;
    return await api.post(`${API_URLS.FINPLAN}/${planId}/stage`, rest?.data);
  }

  static async updateFinancialStage(data) {
    const { planId, stageId, ...rest } = data;
    return await api.put(
      `${API_URLS.FINPLAN}/${planId}/stage/${stageId}`,
      rest?.data,
    );
  }

  static async deleteFinancialStage({ planId, stageId }) {
    return await api.delete(`${API_URLS.FINPLAN}/${planId}/stage/${stageId}`);
  }

  static async createFinancialStageItem(value) {
    const { stageId, itemType, data } = value;
    return await api.post(
      `${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}`,
      data,
    );
  }

  static async updateFinancialStageItem(value) {
    const { id, stageId, itemType, data } = value;
    return await api.put(
      `${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}/${id}`,
      data,
    );
  }

  static async deleteFinancialStageItem(data) {
    const { itemId, stageId, itemType } = data;
    return await api.delete(
      `${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}/${itemId}`,
    );
  }
}
